import { useState } from "react";
import SwitchBox from "../../components/SwitchBox/SwitchBox";
import SearchInput from "../../components/SearchInput/SearchInput";
import Tab from "../../components/Tab/Tab";
import { PendingTable } from "./PendingTable";
import FilterBy from "../../components/FilterBy/FilterBy";
import axios from "../../axios/axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setFloorCaseFilter,
  setFloorCaseOngoingFilter,
  setFloorCaseRedeemedFilter,
  setFloorCaseTabCount,
} from "../../redux/slice/floorCasesSlice";
import { OngoingTable } from "./OngoingTable";
import OngoingDetails from "./View/OngoingDetails";
import RedeemedDetails from "./View/RedeemedDetails";
import { RedeemedTable } from "./RedeemedTable";
import ExpiredDetails from "./View/ExpiredDetails";
import { ExpiredTable } from "./ExpiredTable";
import { useLocation } from "react-router-dom";

const accessToken = localStorage.getItem("agentModuleToken");
export const PendingList = [
  { id: 3, name: "All" },
  { id: 0, name: "Pending" },
  { id: 1, name: "Issued" },
  { id: 2, name: "Rejected" },
];

const Ongoingtabs = [
  { id: 1, name: "Ongoing" },
  { id: 2, name: "Repossessed" },
  { id: 3, name: "All" },

];

const sortOptions = [
  { label: "Recent", value: "2" },
  { label: "Last 7 Days", value: "7" },
  { label: "Last 1 Month", value: "30" },
];
const DefaultFilter = {
  search_key: "",
  vehicle_type: "",
  is_active: 3,
  sortKey: "submitted_date",
  sortOrder: "2",
  tabId: 0,
};
const DefaultOngoinFilter = {
  search_key: "",
  sortKey: "flooring_start_date",
  sortOrder: "2",
  is_active: 1,
  is_repossess: "0",
};
const DefaultRedeemedFilters = {
  search_key: "",
  sortKey: "flooring_start_date",
  sortOrder: "2",
  is_case_close: "1",
  is_expired: "1",
};

const FlooringCases = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pagePermission = location.state;
  const flooringCaseFilter = useSelector(
    (state) => state?.floorCaseFilter?.flooringCaseFileter
  );
  const flooringOngoingCaseFilter = useSelector(
    (state) => state?.floorCaseFilter?.flooringCaseOngoingFilters
  );
  const flooringRedeemedCaseFilter = useSelector(
    (state) => state?.floorCaseFilter?.flooringCaseRedeemedFilters
  );
  const flooringCaseTabCount = useSelector(
    (state) => state?.floorCaseFilter?.flooringCaseTabCount
  );
  const [applyFilters, setApplyFilters] = useState(
    flooringCaseFilter && Object.keys(flooringCaseFilter).length > 0
      ? { ...DefaultFilter, ...flooringCaseFilter }
      : DefaultFilter
  );
  const [ongoingFilters, setOngoingFilters] = useState(
    flooringOngoingCaseFilter &&
      Object.keys(flooringOngoingCaseFilter).length > 0
      ? { ...DefaultOngoinFilter, ...flooringOngoingCaseFilter }
      : DefaultOngoinFilter
  );
  const [redeemedFilters, setRedeemedFilters] = useState(
    flooringRedeemedCaseFilter &&
      Object.keys(flooringRedeemedCaseFilter).length > 0
      ? { ...DefaultRedeemedFilters, ...flooringRedeemedCaseFilter }
      : DefaultRedeemedFilters
  );
  const [tabCount, setTabCount] = useState(flooringCaseTabCount !== undefined ? flooringCaseTabCount : {});

  useEffect(() => {
    if (flooringCaseTabCount !== undefined) {
      setTabCount(flooringCaseTabCount);
    }

  }, [flooringCaseTabCount])

  const GetTabFilterValues = (tabId, key) => {
    if (tabId == 0) {
      return Number(applyFilters[key]);
    } else if (tabId == 1) {
      return ongoingFilters[key];
    } else if (tabId == 2) {
      return redeemedFilters[key];
    } else if (tabId == 3) {
      return redeemedFilters[key];
    } else {
      return "";
    }
  };
  const [activeTab, setActiveTab] = useState(applyFilters?.tabId);

  const [searchValue, setSearchValue] = useState(
    GetTabFilterValues(applyFilters?.tabId, "search_key")
  );
  const [FlooringCases, setFlooringCases] = useState([]);
  const [OngoingCases, setOngoingCases] = useState([]);
  const [OverallSummary, setOverallSummary] = useState({});
  const [FlooringCaseCount, setFlooringCaseCount] = useState({});
  const [sortByValue, setSortByValue] = useState(applyFilters?.sortOrder);
  const [RedeemedCases, setRedeemedCases] = useState([]);
  const [RedeemedCaseCount, setRedeemedCaseCount] = useState({});
  const [RedeemedSummary, setRedeemedSummary] = useState({});
  const [ExiredCases, setExpiredCases] = useState([]);
  //console.log("tabCount", tabCount);

  const tabs = [
    `Pending (${tabCount?.pending})`,
    `Ongoing (${tabCount?.ongoing})`,
    `Redeemed (${RedeemedCases?.length})`,
    `Expired (${ExiredCases?.length})`,
  ];

  const HandleTabCount = (obj) => {
    setTabCount({
      ...tabCount,
      ...obj,
    });
    dispatch(
      setFloorCaseTabCount({
        ...tabCount,
        ...obj,
      })
    );
  };

  const GetFlooringCases = async () => {
    const resp = await axios.post(
      "/flooring/application/list",
      {
        ...applyFilters,
        is_active: applyFilters?.is_active == "3" ? "" : applyFilters?.is_active.toString(),
        sortOrder: applyFilters?.sortOrder == 2 ? "" : applyFilters?.sortOrder,
        sortKey: applyFilters?.sortOrder == 2 ? "created_at" : applyFilters?.sortKey,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      setFlooringCases(resp.data?.data?.applications);
      setFlooringCaseCount(resp.data?.data?.tabCount);
      HandleTabCount({ ...resp.data?.data?.tabCount });
    }
  };

  const GetFlooringOngoingCases = async () => {
    const resp = await axios.post(
      "flooring/application/OngoingList",
      {
        ...ongoingFilters,
        is_active:
          ongoingFilters?.is_active == 3 ? "" : ongoingFilters?.is_active,
        sortOrder:
          ongoingFilters?.sortOrder == 2 ? "" : ongoingFilters?.sortOrder,
        sortKey: ongoingFilters?.sortOrder == 2 ? "flooring_start_date" : ongoingFilters?.sortKey,
        is_repossess: ongoingFilters?.is_active == 2 ? "1" : ongoingFilters?.is_active == 1 ? "0" : "",
      },

      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      //console.log("ONGOINGRESPONSE", resp);
      setOngoingCases(resp.data?.data?.applications);
      setFlooringCaseCount(resp.data?.data?.tabCount);
      HandleTabCount({ ...resp.data?.data?.tabCount });
      setOverallSummary(resp.data?.data?.overall_summary);
    }
  };

  const GetFlooringRedemeedCases = async (tabId) => {
    const resp = await axios.post(
      "flooring/application/redeemedList",
      {
        ...redeemedFilters,
        is_expired: tabId == 2 ? 0 : 1,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      }
    );
    if (resp.status < 400) {
      setRedeemedCaseCount(resp.data?.data?.tabCount);
      setRedeemedSummary(resp.data?.data?.overall_summary);
      // HandleTabCount({
      //   redeemed: tabId == 3 ? flooringCaseTabCount?.redeemed : resp.data?.data?.applications?.length,
      //   expired: tabId == 3 ? resp.data?.data?.applications?.length : 0,
      // });

      if (tabId == 3) {
        setExpiredCases(resp.data?.data?.applications);
      } else {
        setRedeemedCases(resp.data?.data?.applications);

      }
    }
  };

  const HandleFilters = (key, value) => {
    setApplyFilters({
      ...applyFilters,
      ...key,
    });
    dispatch(
      setFloorCaseFilter({
        ...applyFilters,
        ...key,
      })
    );
  };
  const HandleOngoingFilters = (obj) => {
    setOngoingFilters({
      ...ongoingFilters,
      ...obj,
    });
    dispatch(
      setFloorCaseOngoingFilter({
        ...ongoingFilters,
        ...obj,
      })
    );
  };

  const HandleRedeemedFilters = (obj) => {
    setRedeemedFilters({
      ...redeemedFilters,
      ...obj,
    });
    dispatch(
      setFloorCaseRedeemedFilter({
        ...redeemedFilters,
        ...obj,
      })
    );
  };

  const handleSortBy = (label, value) => {
    setSortByValue(value);
    if (applyFilters?.tabId == 0) {
      HandleFilters({ sortOrder: value });
    } else if (applyFilters?.tabId == 1) {
      HandleOngoingFilters({ sortOrder: value });
    } else if (applyFilters?.tabId == 2) {
      HandleRedeemedFilters({ sortOrder: value });
    } else if (applyFilters?.tabId == 3) {
      HandleRedeemedFilters({ sortOrder: value });
    }
  };

  const handleSettingsChange = (idx, title, tabId) => {
    if (applyFilters?.tabId == 0) {
      HandleFilters({ is_active: tabId });
    } else if (applyFilters?.tabId == 1) {
      HandleOngoingFilters({ is_active: tabId });
    } else if (applyFilters?.tabId == 2) {
      HandleRedeemedFilters({ is_active: tabId });
    } else if (applyFilters?.tabId == 3) {
      HandleRedeemedFilters({ is_active: tabId });
    }
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
    if (applyFilters?.tabId == 0) {
      HandleFilters({ search_key: e.target.value });
    } else if (applyFilters?.tabId == 1) {
      HandleOngoingFilters({ search_key: e.target.value });
    } else if (applyFilters?.tabId == 2) {
      HandleRedeemedFilters({ search_key: e.target.value });
    } else if (applyFilters?.tabId == 3) {
      HandleRedeemedFilters({ search_key: e.target.value });
    }
  };

  const ResetSortFunction = () => {
    HandleOngoingFilters({ sortOrder: "2" });
    HandleRedeemedFilters({ sortOrder: "2" });


  }

  const handleTabChange = (tabIndex) => {
    ResetSortFunction();
    setActiveTab(tabIndex);
    HandleFilters({ tabId: tabIndex, sortOrder: "2" });

  };

  const pendingApplications = FlooringCases?.filter((app) => {
    const status = app.cart?.agent_approved_status;
    const activeTab = applyFilters?.is_active;
    if (activeTab === 0) return status === 0;
    if (activeTab === 1) return status === 1;
    if (activeTab === 2) return status === 2
    return true;
  });

  useEffect(() => {
    if (applyFilters?.tabId == 0) {
      GetFlooringCases();
    } else if (applyFilters?.tabId == 1) {
      GetFlooringOngoingCases();
    } else if (applyFilters?.tabId == 2) {
      GetFlooringRedemeedCases(applyFilters?.tabId);
    } else if (applyFilters?.tabId == 3) {
      GetFlooringRedemeedCases(applyFilters?.tabId);
    }
  }, [applyFilters, ongoingFilters, redeemedFilters]);

  useEffect(() => {
    GetFlooringCases();
    GetFlooringOngoingCases();
    GetFlooringRedemeedCases(2);
    GetFlooringRedemeedCases(3);
  }, [])


  return (
    <section className="common_container">
      <header className="common-header flex justify-between flex-wrap gap-4">
        <div className="common-header-body">
          <h1 className=" flex items-center gap-3">Flooring Cases</h1>
        </div>
      </header>
      <section>
        <div className="tab-section">
          <Tab
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={handleTabChange}
          />
        </div>
        <div className="tab-section pt-4">
          <SwitchBox
            tabs={
              activeTab === 0
                ? PendingList
                : activeTab === 1
                  ? Ongoingtabs
                  : null
            }
            settingsHandle={handleSettingsChange}
            value={GetTabFilterValues(applyFilters?.tabId, "is_active")}
          />
          <div className="input-one-line search-block">
            <FilterBy
              defaultName="Filter"
              sortOptions={sortOptions}
              value={GetTabFilterValues(applyFilters?.tabId, "sortOrder")}
              handleSortBy={handleSortBy}
            />
            <SearchInput
              onChange={handleSearchChange}
              value={GetTabFilterValues(applyFilters?.tabId, "search_key")}
            />
          </div>
        </div>
        <div>
          {activeTab === 1 && OngoingCases?.length > 0 && (
            <OngoingDetails OverallSummary={OverallSummary} />
          )}
          {activeTab == 2 && RedeemedCases?.length > 0 && (
            <RedeemedDetails RedeemedSummary={RedeemedSummary} />
          )}
          {activeTab == 3 && ExiredCases?.length > 0 && (
            <ExpiredDetails ExpiredSummary={RedeemedSummary} />
          )}
        </div>
        <div className="tab-body-section">
          <section className="table_section !p-0">
            {activeTab === 0 && (
              <PendingTable
                FlooringCases={pendingApplications}
                pagePermission={pagePermission}
              />
            )}
            {activeTab === 1 && (
              <OngoingTable
                OngoingCases={OngoingCases}
                OverallSummary={OverallSummary}
                pagePermission={pagePermission}
              />
            )}
            {activeTab == 2 && (
              <RedeemedTable
                RedeemedCases={RedeemedCases}
                RedeemedSummary={RedeemedSummary}
                pagePermission={pagePermission}
              />
            )}
            {activeTab == 3 && (
              <ExpiredTable
                ExpiredCases={RedeemedCases}
                ExpiredSummary={RedeemedSummary}
                pagePermission={pagePermission}
              />
            )}
          </section>
        </div>
      </section>
    </section>
  );
};
export default FlooringCases;
